<ng-template #modal let-hide="close">
  <div class="modal-header">
    <h4 i18n class="modal-title">Change the language</h4>
    <button class="border-0 p-0" title="Close this modal" i18n-title (click)="hide()">
      <my-global-icon iconName="cross"></my-global-icon>
    </button>
  </div>


  <a i18n class="help-to-translate" target="_blank" rel="noreferrer noopener" href="https://github.com/Chocobozzz/PeerTube/blob/develop/support/doc/translation.md">
    Help to translate PeerTube!
  </a>

  <div class="modal-body">
    <a *ngFor="let lang of languages" [href]="buildLanguageLink(lang)" [lang]=lang.iso>{{ lang.label }}</a>
  </div>
</ng-template>
